import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'br-select',
    templateUrl: './br-select.component.html',
    styleUrls: ['./br-select.component.scss']
})
export class BrSelectComponent implements OnChanges {

    @Input() defaultChecked: false;
    @Input() checkBoxLabel = '';
    @Input() data;
    @Output() onSelectChange: EventEmitter<any> = new EventEmitter<any>();

    selected;
    checked;

    constructor() {
    }

    ngOnChanges() {
        this.init();
    }

    init() {
        this.checked = this.defaultChecked;
    }


    onChange($event) {
       this.checked = (this.data.length === this.selected.length) ?  true : false;
       this.emit();
    }

    onCheckboxChange($event) {
        this.selected = ($event.checked) ? this.data : [];
        this.checked = $event.checked;
        this.emit();
    }

    emit(): void {

        const payload = {
            isChecked: this.checked,
            collection: this.selected
        };

        this.onSelectChange.emit(payload);
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/forms/br-select/br-select.component.ts